/**
 * Transform options offered in the mapping-profile column editors.
 */

export interface TransformOption {
  value: string;
  label: string;
  hint?: string;
}

export interface TransformOptionGroup {
  label: string;
  options: TransformOption[];
}

export const TRANSFORM_OPTION_GROUPS: TransformOptionGroup[] = [
  {
    label: "Basic",
    options: [{ value: "none", label: "None" }],
  },
  {
    label: "Amounts",
    options: [
      {
        value: "svc_to_total",
        label: "Add Service Charge",
        hint: "Adds the service charge column into this amount. QuickBill expects the line Total and Total Excluding Tax to already include service charge.",
      },
      {
        value: "add_columns",
        label: "Sum Columns",
        hint: "Adds two or more source columns together.",
      },
    ],
  },
  {
    label: "Code lists",
    options: [
      { value: "enum_tax_type", label: "Tax Type" },
      { value: "enum_classification", label: "Classification" },
      { value: "enum_measurement", label: "Measurement" },
      { value: "enum_state", label: "State" },
      { value: "enum_payment_mode", label: "Payment Mode" },
      { value: "enum_registration_type", label: "Reg. Type" },
    ],
  },
  {
    label: "Text & dates",
    options: [
      { value: "date_reformat", label: "Date" },
      {
        value: "excel_date_serial",
        label: "Excel Date Serial",
        hint: "For date columns exported as raw numbers (e.g. 45870).",
      },
      { value: "country_alpha2_to_alpha3", label: "Country" },
      { value: "na_to_null", label: "NA to Null" },
      { value: "numeric_to_string", label: "Num to Str" },
      {
        value: "normalize_contact",
        label: "Phone Number",
        hint: "Strips spaces, dashes and # from phone numbers.",
      },
      {
        value: "strip_chars",
        label: "Strip Characters",
        hint: "Removes the characters you list from the value.",
      },
      {
        value: "pad_left",
        label: "Pad Left",
        hint: "Pads short values with leading zeros.",
      },
      {
        value: "value_map",
        label: "Value Map",
        hint: "Rewrites specific source values to values of your choosing.",
      },
    ],
  },
];

const OPTIONS_BY_VALUE = new Map(
  TRANSFORM_OPTION_GROUPS.flatMap((g) => g.options).map((o) => [o.value, o]),
);

export const transformHint = (value: string | undefined): string | undefined =>
  value ? OPTIONS_BY_VALUE.get(value)?.hint : undefined;
